import React from 'react';

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--hr-bg)' }}>
      
      {/* Hero */}
      <section className="py-16 sm:py-20" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 
            className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold"
            style={{ color: 'var(--hr-text)' }}
          >
            Mentions légales & CGV
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 sm:py-16">
        <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          
          <div>
            <h2 className="font-['Playfair_Display'] text-2xl font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>
              Éditeur du site
            </h2>
            <p className="text-base leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
              Le site homely-renovation.ch est édité et exploité par <strong>Homely Solutions</strong>.
            </p>
            <p className="text-base leading-relaxed mt-2" style={{ color: 'var(--hr-text-muted)' }}>
              <strong>Homely Rénovation</strong> est un service / une activité de Homely Solutions.
            </p>
          </div>

          <div>
            <h2 className="font-['Playfair_Display'] text-2xl font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>
              Hébergement
            </h2>
            <p className="text-base leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
              Le site est hébergé en Suisse.
            </p>
          </div>

          <div>
            <h2 className="font-['Playfair_Display'] text-2xl font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>
              Conditions générales de vente
            </h2>
            <p className="text-base leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
              Les devis sont établis sans engagement. Toute prestation fait l'objet d'un contrat écrit précisant le détail des travaux, le planning prévisionnel et le montant total.
            </p>
            <p className="text-base leading-relaxed mt-2" style={{ color: 'var(--hr-text-muted)' }}>
              Le paiement s'effectue selon un échéancier défini contractuellement (acompte, avancements, solde à réception).
            </p>
          </div>

          <div>
            <h2 className="font-['Playfair_Display'] text-2xl font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>
              Propriété intellectuelle
            </h2>
            <p className="text-base leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
              Tous les contenus présents sur ce site (textes, images, logos) sont la propriété de Homely Solutions ou utilisés avec autorisation. Toute reproduction non autorisée est interdite.
            </p>
          </div>

          <div>
            <h2 className="font-['Playfair_Display'] text-2xl font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>
              Protection des données personnelles
            </h2>
            <p className="text-base leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
              Les informations collectées via les formulaires de contact ou de devis sont destinées à Homely Solutions et ne sont en aucun cas transmises à des tiers.
            </p>
            <p className="text-base leading-relaxed mt-2" style={{ color: 'var(--hr-text-muted)' }}>
              Conformément à la législation suisse, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}